import React from "react";
import { Box, Typography, Alert, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import CampaignTextValidationErrors from "./CampaignTextValidationErrors";
import { renderWithTokenHighlight } from './campaignTextUtils';

type Props = {
  initialText: string;
  alertText?: string;
  alertClosed: boolean;
  handleCloseAlert: () => void;
  validationErrors: any[];
  showValidationErrors: boolean;
};

export default function CampaignTextDisplay({
  initialText,
  alertText,
  alertClosed,
  handleCloseAlert,
  validationErrors,
  showValidationErrors
}: Props) {
  return (
    <Box sx={styles.scrollableContent}>
      <Typography variant="h3" sx={styles.textOverflow}>
        {renderWithTokenHighlight(initialText)}
      </Typography>
      <CampaignTextValidationErrors
        validationErrors={validationErrors}
        showValidationErrors={showValidationErrors}
      />
      {!!alertText && !alertClosed && (
        <Alert
          variant="filled"
          severity="success"
          sx={styles.alert}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleCloseAlert}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {alertText}
        </Alert>
      )}
    </Box>
  );
}

const styles = {
  scrollableContent: {
    flex: 1,
    overflow: 'auto',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  textOverflow: {
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    width: "100%",
    padding: "20px 16px",
    background: "#eee",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: 500,
    marginBottom: '16px',
    flexShrink: 0,
  },
  alert: {
    padding: "8px",
    marginTop: "16px"
  }
};
